import React, { useEffect } from 'react';
import { useModalManager } from '@/components/common/Modal';
import FeedbackModal from '@/components/staffer/HelpButton/FeedbackModal';

interface SidebarFeedbackTriggerProps {
  currentPageUrl: string;
  staffer: {
    email: string;
    firstName: string;
    lastName: string;
  };
}

const SidebarFeedbackTrigger = ({ currentPageUrl, staffer }: SidebarFeedbackTriggerProps) => {
  const { isOpen, open, close } = useModalManager();

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const el = e.target as HTMLElement;
      const target = el.closest('button[data-action-url$="#feedback"]');
      if (!target || !target.closest('#left_nav_bar')) return;

      e.preventDefault();
      open();
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [open]);

  return (
    <FeedbackModal
      close={close}
      currentPageUrl={currentPageUrl}
      isOpen={isOpen}
      staffer={staffer}
    />
  );
};

export default SidebarFeedbackTrigger;
